import { render } from "./TemplateHeroBackground.vue?vue&type=template&id=4cf9818a&scoped=true"
import script from "./TemplateHeroBackground.vue?vue&type=script&lang=js"
export * from "./TemplateHeroBackground.vue?vue&type=script&lang=js"

import "./TemplateHeroBackground.vue?vue&type=style&index=0&id=4cf9818a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf9818a"],['__file',"src/scripts/portfolioEditor/components/themes/theme-parts/TemplateHeroBackground.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4cf9818a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cf9818a', __exports__)) {
    api.reload('4cf9818a', __exports__)
  }
  
  module.hot.accept("./TemplateHeroBackground.vue?vue&type=template&id=4cf9818a&scoped=true", () => {
    api.rerender('4cf9818a', render)
  })

}


export default __exports__